import React, { useState } from 'react';

import moment from 'moment-timezone';

import { HorizontallyCenteringContainer, VerticalSeparator } from '../utils';
import { inPromoPeriod } from './utils';

export default function VoucherLikePromo({
    PromotionModalComponent,
    token,
    memberData,
    updateMemberData,
    onlyShowImage = false,
} = {}) {
    const isActive = (PromotionModalComponent.__override_condition__ && PromotionModalComponent.__override_condition__(memberData)) || inPromoPeriod(PromotionModalComponent);

    const [showModal, setShowModal] = useState(false);

    const doShowPromoModal = () => isActive && setShowModal(true);

    const DefaultCouponLikeComponent = ({ showPromoModal }) => {
        const imgSrc = PromotionModalComponent.__imgSrc__ || 'generic-promo-image.jpg'
        const textHeading = PromotionModalComponent.__heading__ || 'New Promotion!'
    
        const showStart = !isActive && PromotionModalComponent.__start_date__ && PromotionModalComponent.__display_start_date__ && (new Date() >= PromotionModalComponent.__display_start_date__) && (new Date() < PromotionModalComponent.__start_date__);
        const showPromoOver = PromotionModalComponent.__end_date__ && (PromotionModalComponent.__end_date__ < new Date());
        const showEnd = !showPromoOver && PromotionModalComponent.__end_date__ && ((PromotionModalComponent.__end_date__.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24 * 365.25) < 5)

        return (
            <>
                <div className='coupon' style={Object.assign(isActive ? {} : { backgroundColor: '#8b0000' }, isActive ? PromotionModalComponent.__additional_styles__ || {} : {})} onClick={showPromoModal}>
                    <img
                        alt={textHeading} src={imgSrc}
                        {...(onlyShowImage ? { className: 'coupon-full-width' } : {})}
                    />
                    {
                        !onlyShowImage && (
                            <div className='coupon-text'>
                                <div className='coupon-text-heading'>
                                    {
                                        textHeading.split('|').map((text, idx, arr) => (
                                            <React.Fragment key={`text-frag-${idx}`}>
                                                <span>{text}</span>{ idx + 1 < arr.length && <br/> }
                                            </React.Fragment>
                                        ))                            
                                    }
                                </div>
                                {
                                    showStart && (
                                        <div className='coupon-text-expiry'>
                                            Available starting from {moment(PromotionModalComponent.__start_date__).format('DD MMMM YYYY')}
                                        </div>
                                    )
                                }
                                {
                                    showPromoOver && !showStart && (
                                        <div className='coupon-text-expiry'>
                                            This promotion has ended
                                        </div>
                                    )
                                }
                                {
                                    showEnd && !showStart && (
                                        <div className='coupon-text-expiry'>
                                            Available till {moment(PromotionModalComponent.__end_date__).format('DD MMMM YYYY')}
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                </div>
                {
                    !!PromotionModalComponent.__below_button_text__ && !! PromotionModalComponent.__below_button_text__(memberData) && (
                        <HorizontallyCenteringContainer>
                            <p style={{ fontSize: '0.9em' }}>{PromotionModalComponent.__below_button_text__(memberData)}</p>
                        </HorizontallyCenteringContainer>
                    )
                }
            </>
        );
    };
    const DisplayWidget = PromotionModalComponent.__display_widget__ || DefaultCouponLikeComponent;

    return (
        <>
            <VerticalSeparator height='3px'/>
            <DisplayWidget showPromoModal={doShowPromoModal} memberData={memberData}/>
            <PromotionModalComponent
                showModal={showModal}
                setShowModal={setShowModal}
                token={token}
                memberData={memberData}
                updateMemberData={updateMemberData}
            />
            <VerticalSeparator height='3px'/>
        </>
    )
}
